import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { IonApp, IonRouterOutlet, Platform } from '@ionic/angular/standalone';

@Component({
  selector: 'app-root',
  template: '<ion-app><ion-router-outlet /></ion-app>',
  imports: [IonRouterOutlet, IonApp],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainComponent implements OnInit {
  private platform = inject(Platform);

  public ngOnInit(): void {
    void this.platform.ready().then(() => {
      setTimeout(() => {
        document.getElementById('init-app-loading')?.remove();
      }, 1000);
    });
  }
}
